import { useEffect, useEffectEvent } from 'react';
import { useLocation } from 'react-router-dom';

import { AnalyticsService } from '@/services';

export const usePageViewEvents = () => {
  const { pathname, state, search } = useLocation();

  const logPageLoad = useEffectEvent(() => {
    const queryParams = Object.fromEntries(
      new URLSearchParams(search).entries(),
    );
    const { campaign_id: campaignId, newsletter: isFromNewsletter } =
      queryParams;
    AnalyticsService.pageLoad({
      queryParams,
      campaignId,
      isFromNewsletter,
      pathname,
    });
  });

  useEffect(() => {
    logPageLoad();
  }, []);

  useEffect(() => {
    const referrer = state?.referrer;
    const [section, resourceId] = pathname?.split('/').slice(1) || [];

    if (referrer) {
      AnalyticsService.clickThrough({
        target: pathname,
        referrer,
        section,
        resourceId,
      });
    }

    const location = referrer || { page: section };
    AnalyticsService.pageView(location);
  }, [pathname, state?.referrer]);
};
